import Vue from "vue";
import { Button, Select, Dialog, Form, FormItem, Input, Message, Upload, Drawer } from "element-ui";

Vue.use(Button);
Vue.use(Select);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Drawer);

Vue.prototype.$message = Message;
